import { GroupsDiscoverScreen } from './groups-discover-screen'
import { SearchGroupsSort, searchGroupsQuery, useSearchGroupsQuery } from './queries'
import { FilterOption } from '../../components'
import { useAuth } from 'app/provider/auth'
import {
  useGroupCategoriesQuery,
  useUserGroupJoinRequestsQuery,
  useUserGroupsQuery,
  userGroupJoinRequestsQuery,
  userGroupsQuery,
} from '../../queries'
import { useState } from 'react'

export const GroupsDiscoverScreenContainer = ({ HeaderComponent }) => {
  const { user } = useAuth()
  const [refreshing, setRefreshing] = useState(false)

  const { data: userGroupsData } = useUserGroupsQuery({
    variables: {
      ...userGroupsQuery.defaultVariables,
    },
    skip: !user,
    fetchPolicy: 'cache-and-network',
  })

  const { data: userGroupJoinRequestsData } = useUserGroupJoinRequestsQuery({
    variables: {
      ...userGroupJoinRequestsQuery.defaultVariables,
    },
    fetchPolicy: 'cache-and-network',
    skip: !user,
  })

  const { data: groupCategoriesData, refetch: refetchGroupCategories } = useGroupCategoriesQuery({
    fetchPolicy: 'cache-and-network',
  })

  const {
    data: searchGroupsData,
    previousData: searchGroupsPreviousData,
    refetch: refetchSearchGroups,
    loading: searchLoading,
    fetchMore,
    networkStatus,
  } = useSearchGroupsQuery({
    variables: searchGroupsQuery.defaultVariables,
    notifyOnNetworkStatusChange: true,
  })

  const handleSearch = (query: string, filters: FilterOption[], sort: SearchGroupsSort) => {
    refetchSearchGroups({
      page: 1,
      sort: sort || SearchGroupsSort.NameAsc,
      limit: 10,
      searchTerm: query.length > 2 ? query : '',
      categories: filters.map((f) => f.value),
    })
  }

  const totalDocs = searchGroupsData?.searchGroups?.totalDocs || 0
  const hasMore = totalDocs > (searchGroupsData?.searchGroups?.docs.length || 0)

  const handleFetchMore = async () => {
    if (!hasMore || !searchGroupsData) return
    await fetchMore({
      variables: {
        page: searchGroupsData.searchGroups.page + 1,
      },
    })
  }

  const handlePullToRefresh = async () => {
    setRefreshing(true)
    await Promise.all([
      refetchGroupCategories(),
      refetchSearchGroups(searchGroupsQuery.defaultVariables),
    ])
    setRefreshing(false)
  }

  // Reuse the previous data while the new data is fetching to avoid flickering
  const groups =
    searchGroupsData?.searchGroups?.docs || searchGroupsPreviousData?.searchGroups?.docs || []
  const groupCategories = groupCategoriesData?.groupCategories?.docs || []
  const userGroups = userGroupsData?.userGroups?.docs || []
  const userGroupJoinRequests = userGroupJoinRequestsData?.userGroupJoinRequests?.docs || []

  const searchFetchingMore = networkStatus === 3
  const searchFetching = networkStatus === 2

  return (
    <GroupsDiscoverScreen
      HeaderComponent={HeaderComponent}
      user={user}
      groups={groups}
      userGroups={userGroups}
      userGroupJoinRequests={userGroupJoinRequests}
      totalResults={totalDocs}
      groupCategories={groupCategories}
      onSearchChange={handleSearch}
      searchLoading={searchLoading || searchFetching}
      searchFetchingMore={searchFetchingMore}
      hasMore={hasMore}
      fetchMore={handleFetchMore}
      refreshing={refreshing}
      onPullToRefresh={handlePullToRefresh}
    />
  )
}
